import script from "./MarkdownText.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarkdownText.vue?vue&type=script&lang=ts&setup=true"

import "./MarkdownText.vue?vue&type=style&index=0&id=39f343e0&lang=less"

const __exports__ = script;

export default __exports__